import script from "./TagEditorMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagEditorMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./TagEditorMoelcule.css?vue&type=style&index=0&id=c8c4c74c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8c4c74c"]])

export default __exports__